import * as React from "react"
import { observer } from "mobx-react-lite"
import { WebViewProps } from "react-native-webview"
import { ForwardedRef, useCallback, useEffect, useMemo, useState } from "react"
import { useStores } from "../../models"
import {
  WebViewSource,
  WebViewSourceUri
} from "react-native-webview/lib/WebViewTypes"
// import Share from "react-native-share"
import { goBack, navigate } from "../../navigators"
import {
  Appearance,
  Linking
} from "react-native"
import { handleDeepLink } from "../../utils/handle-deep-link"

const IFRAME = {
  border: 0
}

export interface JalaWebViewProps extends WebViewProps {
  colorScheme?: "light"|"dark",
  cacheKey?: string,
  onSetData?: (data: any) => void
}

/**
 * Describe your component here
 */
export const JalaWebView = observer(function JalaWebView(props: JalaWebViewProps, ref: ForwardedRef<HTMLIFrameElement>) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    source: sourceProps = {},
    cacheKey: cacheKeyProps,
    onLoad,
    onError,
    onSetData
  } = props;
  const {
    appStore,
    tokenStore,
    homeStore
  } = useStores()
  const [cacheKey, setCacheKey] = useState<string>()

  const source: WebViewSource = useMemo(() => {
    if (!cacheKey) return null;
    const uri = new URL((sourceProps as WebViewSourceUri).uri)
    uri.searchParams.set('cache_key', cacheKey)
    uri.searchParams.set('color_scheme', colorScheme)
    if (appStore.farmStore?.farmId)
      uri.searchParams.set('farm_id', `${appStore.farmStore.farmId}`)
    return {
      ...sourceProps,
      uri: uri.toString()
    }
  }, [appStore, colorScheme, sourceProps, cacheKey])

  useEffect(() => {
    if (cacheKeyProps) {
      setCacheKey(tokenStore.cacheKey);
    } else {
      tokenStore.requestCacheKey()
        .then(() => {
          setCacheKey(tokenStore.cacheKey);
        })
    }
  }, [tokenStore, cacheKeyProps])

  const handleMessageData = useCallback((data: string) => {
    if (!(typeof data === 'string' && data.startsWith('{'))) return;
    try {
      const { action, payload } = JSON.parse(data);
      switch (action) {
        // case 'share':
        //   Share.open({ ...payload }).catch()
        //   break;
        case 'back':
          goBack('Home.Stack');
          break;
        case 'navigate':
          if (payload?.screen)
            navigate('Home.Stack', payload?.screen, payload?.params)
          break;
        case 'open':
          if (payload?.url) {
            const deepLinked = handleDeepLink({ url: payload?.url })
            if (!deepLinked) Linking.openURL(payload?.url).catch()
          }
          break;
        case 'home-refresh':
          homeStore.onRefresh()
          break;
        case 'set-data':
          onSetData && onSetData(payload)
          break;
        default:
          break;
      }
    } catch (e: unknown) {
      console.warn(e);
    }
  }, [homeStore, onSetData])

  const onMessage = useCallback(async (e: MessageEvent) => {
    const { data } = e;
    handleMessageData(data);
  }, [handleMessageData]);

  useEffect(() => {
    window.addEventListener('message', onMessage)
    return () => {
      window.removeEventListener('message', onMessage)
    }
  }, [onMessage])

  return (
    !!source && (
      <iframe
        id="jala-web-view"
        ref={ref}
        src={source.uri}
        height="100%" width="100%"
        style={IFRAME}
        onLoad={onLoad as any}
        onError={onError as any}
      />
    )
  )
}, { forwardRef: true })
